import React, { useState, useEffect } from 'react';
import { Bug, Lightbulb, Plus } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import api from '../services/api';
import { openBugReport } from '../utils/errorCollector';

const STATUS = {
    NEW: ['New', '#6366f1'], IN_PROGRESS: ['In progress', '#d97706'], RESOLVED: ['Resolved', '#10b981'],
    CLOSED: ['Closed', '#6b7280'], WONT_FIX: ["Won't fix", '#6b7280'],
};
const muted = { color: 'var(--text-muted)', fontSize: 13 };

// The reports this person has sent and where they stand.
const MyBugReports = () => {
    const [rows, setRows] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const load = () => api.get('/bugs/mine').then(r => setRows(r.data)).catch(e => setError(e.response?.data?.error || 'Failed to load your reports'));
        load();
        // A report sent from the dialog while this page is open shows up when it closes.
        const onFocus = () => load();
        window.addEventListener('focus', onFocus);
        return () => window.removeEventListener('focus', onFocus);
    }, []);

    return (
        <div className="container" style={{ padding: '2rem 1rem', maxWidth: 900 }}>
            <PageHeader />
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                <h1 style={{ margin: 0, flex: 1 }}>My reports</h1>
                <button className="btn btn-primary" style={{ padding: '8px 14px', fontSize: 14 }} onClick={() => openBugReport()}><Plus size={14} /> New report</button>
            </div>
            <p style={{ ...muted, fontSize: 15 }}>Bugs and suggestions you have sent. You get an email when one is resolved.</p>
            {error && <p style={{ color: '#ef4444' }}>{error}</p>}
            {rows && rows.length === 0 && <p style={muted}>You haven’t sent any reports yet.</p>}
            {rows && rows.length > 0 && (
                <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
                    {rows.map(r => {
                        const [label, color] = STATUS[r.status] || STATUS.NEW;
                        return (
                            <div key={r.id} data-testid="my-report" style={{ display: 'flex', gap: 12, alignItems: 'center', padding: '12px 16px', borderTop: '1px solid var(--border)', flexWrap: 'wrap' }}>
                                {r.type === 'BUG' ? <Bug size={16} color="#ef4444" /> : <Lightbulb size={16} color="#d97706" />}
                                <div style={{ flex: '1 1 260px' }}>
                                    <div style={{ color: 'var(--text-main)' }}><strong>{r.ref}</strong> · {r.title}</div>
                                    <div style={muted}>{new Date(r.createdAt).toLocaleDateString()}{r.severity && ` · ${r.severity.toLowerCase()}`}{r.pagePath && ` · ${r.pagePath}`}</div>
                                </div>
                                <span style={{ fontSize: 12, fontWeight: 600, color, border: `1px solid ${color}`, borderRadius: 12, padding: '2px 10px' }}>{label}</span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default MyBugReports;
